import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { useFunnel } from '../../contexts/FunnelContext';
import { phones, brand } from '../../data/siteConfig';
export function FunnelHeader() {
  const {
    t
  } = useFunnel();
  return <header className="sticky top-0 z-30 border-b border-ink-700 bg-ink" data-id="element-435" data-mp="3oyg8meotmyk1">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-3 px-4 sm:px-6" data-id="element-436" data-mp="3k1psxsgxi4z5">
        <div className="flex items-center gap-2" aria-label={`${brand.mark} ${brand.word}`} data-id="element-437" data-mp="3fzmd6rn88e82">
          <span className="rounded bg-lime px-1.5 py-0.5 font-display text-base font-black text-ink sm:text-lg" data-id="element-438" data-mp="3b001wnqyl81w">{brand.mark}</span>
          <span className="whitespace-nowrap font-display text-base font-black tracking-tight text-white min-[400px]:text-lg sm:text-2xl" data-id="element-439" data-mp="361oraasuatim">{brand.word}</span>
          <span className="hidden text-xs font-medium text-ink-300 lg:inline" data-id="element-440" data-mp="14abq9wtzt5ru">{t('brandSub')}</span>
        </div>
        <div className="flex items-center gap-2" data-id="element-441" data-mp="zagzdta7wg6s">
          <a href={phones.ai.href} aria-label={`${t('callKyle')} ${phones.ai.display} — ${t('aiLabel')}`} className="flex h-10 items-center gap-2 rounded-lg bg-lime px-3 text-sm font-bold text-ink transition-[background-color] duration-150 ease-out hover:bg-white" data-id="element-442" data-mp="z8mg0jelgw4t">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-443" data-mp="3gqlwe9eoiz53" />
            <span className="hidden whitespace-nowrap lg:inline" data-id="element-444" data-mp="3gr3wjh4gpxia">
              {t('callKyle')} · {phones.ai.display}
            </span>
            <span className="hidden whitespace-nowrap sm:inline lg:hidden" data-id="element-445" data-mp="d9vht6517drs">{phones.ai.display}</span>
            <span className="sm:hidden" data-id="element-446" data-mp="3uqd7a19wfzev">{t('callShort')}</span>
          </a>
        </div>
      </div>
    </header>;
}